// Der Vorschlag fuer die Funktion an "Arbeitet für" aus dem Wortlaut einer
// Signatur (ST-PTY-001, S1b). Gespeichert wird ein Code der Werteliste aus 0048,
// nie der Wortlaut (Option C verworfen); die Person sieht den Vorschlag im Feld
// und bestaetigt ihn mit der einen Hauptaktion.
//
// REGELN STATT KI und lieber kein Vorschlag als ein erfundener (5.2 Nr. 14):
// passt kein Stichwort oder passen zwei verschiedene Funktionen ("Marketing und
// Vertrieb"), bleibt das Feld leer und der Wortlaut steht unter "Nicht
// übernommen". "other" wird nie vorgeschlagen -- "Sonstiges" sagt nichts, was
// die Person nicht selbst waehlen koennte.

/**
 * Stichworte je Code, deutsch und englisch, als Wortanfang gelesen ("Lektor"
 * trifft "Lektorin" und "Lektorat"). Kurze Abkuerzungen stehen als ganzes Wort
 * ("PR" trifft nicht "Produktion"). Die Leitung steht zuletzt: "Leitung
 * Marketing" ist Marketing, erst ohne Fachgebiet ist sie die Geschaeftsfuehrung.
 */
const STICHWORTE: readonly (readonly [string, readonly RegExp[]])[] = [
  ['editorial', [/^lektor/u, /^redakt/u, /^editor/u, /^programmleit/u, /^programmplan/u]],
  ['press', [/^presse/u, /^pr$/u, /^public$/u, /^kommunikation/u, /^communications?$/u, /^öffentlichkeitsarbeit/u]],
  ['marketing', [/marketing/u]],
  ['sales', [/vertrieb/u, /^sales$/u, /^key$/u, /^außendienst/u, /^verkauf/u, /^business$/u]],
  ['purchasing', [/einkauf/u, /^einkäuf/u, /^purchas/u, /^procurement/u, /^buyer$/u, /^beschaffung/u]],
  ['rights_licensing', [/^rechte/u, /^lizenz/u, /^rights?$/u, /^licens/u, /^foreign$/u]],
  ['events', [/^veranstaltung/u, /^event/u]],
  ['production', [/^herstell/u, /^produktion/u, /^production$/u]],
  ['accounting', [/buchhalt/u, /^accounting$/u, /^finanz/u, /^finance$/u, /^controll/u, /^rechnungswesen/u]],
  ['customer_service', [/kundenservice/u, /^kundenbetreuung/u, /^kundendienst/u, /^customer$/u, /^support$/u]],
  ['assistant', [/^assist/u, /^sekretariat/u, /^office$/u]],
  ['management', [/^geschäftsführ/u, /^geschäftsleitung/u, /^ceo$/u, /^inhaber/u, /^owner$/u, /^managing$/u, /^vorstand/u, /^gründer/u, /^founder$/u, /^verleger/u, /^verlagsleit/u]],
];

/** Der Code fuer den Wortlaut, oder undefined, wenn keiner eindeutig passt. */
export function roleCodeForFunction(wortlaut: string | undefined): string | undefined {
  if (wortlaut === undefined) return undefined;
  const woerter = wortlaut.toLocaleLowerCase('de-DE').split(/[^\p{L}]+/u).filter((wort) => wort !== '');
  const treffer = STICHWORTE.filter(([, muster]) => woerter.some((wort) => muster.some((m) => m.test(wort)))).map(([code]) => code);
  const fachlich = treffer.filter((code) => code !== 'management');
  if (fachlich.length === 1) return fachlich[0];
  if (fachlich.length > 1) return undefined;
  return treffer.length === 1 ? treffer[0] : undefined;
}
